import React from 'react';
import MainModal from 'components/ModalMain';
import { Container } from './styles';
import { FailIcon } from 'assets/icons';

const ModalOutOfService = ({
  isOpen,
  setClose
}) => {

  return (
    <MainModal
      isOpen={isOpen}
      setClose={setClose}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <FailIcon />
        <div className='title'>Out of Service</div>
        <div className='text'>Something went wrong while loading this page. Please refresh or try again later.</div>
      </Container>
    </MainModal>
  );
}

export default ModalOutOfService;
